import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

import { Provider } from "react-redux";
import { store } from "./redux/configureStore";
import ReactPixel from "react-facebook-pixel";
import { HelmetProvider } from "react-helmet-async";

ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID);
ReactPixel.pageView();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();